 <template>
    <div class="bibliometric-atlas">
        <div class="page-cont" >
            <h2>计量可视化分析结果</h2>
            <div  >
                <div class="atlas-top-btn" >  
                    <el-button type="success" icon="el-icon-document" @click="report" :loading='isReport'>生成报告</el-button>
                </div>
                <el-tabs v-loading="atlasLoad" v-model="activeName" @tab-click="handleClick" > 
                    <el-tab-pane label="发文趋势分析" name="first" :lazy="false"> 
                        <div v-loading='lineLoad' class="echarts-box" ref="echarts_line"></div>
                    </el-tab-pane> 
                    <el-tab-pane label="作者分析" name="second" :lazy="false"> 
                        <div v-loading='authorLoad'>
                            <div  class="echarts-box box-h" ref="author_bar"></div>
                            <complex v-if="graphList.length!=0" :complexType="'author'" :graphList="graphList" :containerId="'container'" @comples_img="comples_img"></complex> 
                            <div class="echarts-box" ref="echart_map"> </div>
                            <atlasTalbe v-if="authorTable&&authorTable.length!=0" :tableType="'statistics'" :tableTit="'高发文作者统计（前20位）'" :tableData="authorTable"></atlasTalbe> 
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="机构分析" name="third" :lazy="false"> 
                        <div v-loading='groupLoad' class="echarts-box box-h" ref="group_bar"></div>
                        <complex v-if="institutionGraph.length!=0" :complexType="'group'" :graphList="institutionGraph" :containerId="'container1'"  @comples_img="comples_img"></complex>
                        <atlasTalbe v-if="institutionTable&&institutionTable.length!=0" :tableType="'statistics'"  :tableTit="'高发文机构统计（前20位）'" :tableData="institutionTable"></atlasTalbe>
                    </el-tab-pane>
                    <el-tab-pane label="关键词词云图" name="fourth" :lazy="false">  
                        <div v-loading='wordLoad' class="echarts-box word-box" ref="echarts_word"></div>
                        <atlasTalbe v-if="wordTable&&wordTable.length!=0" :tableType="'word'" :tableTit="'高频关键词统计（前20位）'" :tableData="wordTable"></atlasTalbe>
                        
                    </el-tab-pane>
                    <el-tab-pane label="关键词共现网络分析" name="five" :lazy="false">
                        <div v-loading="keywordPairLoad">
                            <complex v-show="keywordGraph.length!=0" :complexType="'keywordPair'"  :graphList="keywordGraph" :containerId="'container2'"  @comples_img="comples_img"></complex>
                            <atlasTalbe v-if="keywordPairTable&&keywordPairTable.length!=0"  :tableType="'pair'" :tableTit="'关键词共现分析表'" :tableData="keywordPairTable"></atlasTalbe>
                        </div> 
                    </el-tab-pane>
                    <el-tab-pane label="关键词未来趋势分析" name="six" :lazy="false"> 
                        <div v-loading="heatmapLoad" class="echarts-box box-h" ref="keyWord_heatmap">
                          <div v-if="keyWordHeatmapUrl" @click="save_pic(keyWordHeatmapUrl,'关键词未来趋势分析')"  class="down-img">
                                <div  class="down"></div>
                            </div>
                            <div class="pane-img">
                                <img width="100%" :src="keyWordHeatmapUrl" alt="">
                            </div>  
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="关键词突变分析" name="seven" :lazy="false"> 
                        <div v-loading="burstLoad">
                            <div class="pane-img">
                                <div v-if="keywordsBurst" @click="save_pic(keywordsBurst,'关键词突变分析')"  class="down-img">
                                    <div  class="down"></div>
                                </div>
                                <img width="100%" :src="keywordsBurst" alt="">
                            </div>  
                            <atlasTalbe v-if="keywordsMutation&&keywordsMutation.length!=0" :tableType="'mutation'" :tableTit="'关键词突变分析'" :tableData="keywordsMutation"></atlasTalbe>
                        </div> 
                    </el-tab-pane>
                     <el-tab-pane label="关键词聚类" name="eight " :lazy="false">  
                        <div v-loading="curveLoad"> 
                            <div v-if="curveGraph.length!=0">
                                <div class="curve-tit">
                                    <p>核心关键词聚类图谱</p>
                                    <p>Q={{ curveMetrics.Q_value.toFixed(2) }}</p>
                                    <p>S={{ curveMetrics.doc_level_S_value.toFixed(2) }}</p>
                                    <p>CH={{ curveMetrics.doc_level_CH_value.toFixed(2)}}</p>
                                </div>
                                <complex  :complexType="'curveLPair'" :curveMetrics="curveMetrics" :graphList="curveGraph" :containerId="'container3'"  @comples_img="comples_img"></complex>
                            </div>  
                            
                            <div  class="echarts-box" ref="echarts_curve"></div>
                            <atlasTalbe v-if="clusterScatterTable&&clusterScatterTable.length!=0" :tableType="'keyworCurve'" :tableTit="'关键词聚类信息表'" :tableData="clusterScatterTable"></atlasTalbe>
                            <!-- <div class="pane-img">
                                <div v-if="keyworCurve" @click="save_pic(keyworCurve,'关键词聚类')"  class="down-img">
                                    <div  class="down"></div>
                                </div>
                                <img width="100%" :src="keyworCurve" alt="">
                            </div> -->
                            <!-- <div class="demo-ruleForm"> 
                                <p class="label">输入K值：</p>
                                <el-input class="k-input" type="number" v-model="kValue"></el-input>
                                <el-button type="primary" @click="analys_k" :loading="analysLoad">分析</el-button> 
                            </div>   -->
                        </div>
                        <!-- <div v-loading="analysLoad" class="pane-img">
                            <div v-if="clusterScatterUrl" @click="save_pic(clusterScatterUrl,' K值分析')"  class="down-img">
                                <div  class="down"></div>
                            </div>
                            <img width="100%" :src="clusterScatterUrl" alt="">
                            <atlasTalbe v-if="clusterScatterTable&&clusterScatterTable.length!=0" :tableType="'keyworCurve'" :tableTit="'关键词聚类信息表'" :tableData="clusterScatterTable"></atlasTalbe>
                        </div>  -->
                    </el-tab-pane>
                    
                </el-tabs> 
            </div> 
        </div> 
    </div>
</template>

<script>
import {analysisVisualization,analysisClusterKeywords,provinceCityStatistics,bibliometricsGenerateReport} from '../../io/api.js';
import {mapState,mapMutations,mapActions} from 'vuex' 
// import analysisVisualizationJson from './analysisVisualization.js' 
import saveImge from '../../utils/saveImg.js';
import chain_nh from './chain_nh.json' 
import chinaJaon from './chinaAreas.json' 
import '../../utils/echartsWord.js'
import complex from './comps/complex.vue' 
import atlasTalbe from './comps/atlas_talbe.vue'
import 'echarts-wordcloud' 
export default {
    props: ['keyWord'],
    components: { 
        complex,
        atlasTalbe,
    },
    data() {
        return {
            // kValue:'',
            atlasLoad:false,  
            echartLine:'', 
            authorBar:'', 
            groupBar:'',
            echartWord:'',
            myChartMap:'',
            keyWordHeatmap:'',
            echartsCurve:'',//关键词聚类折线图
            activeName:'first',
            activeTabIndex:1,
            lineLoad:false,
            authorLoad:false,
            groupLoad:false,
            wordLoad:false,
            keywordPairLoad:false,
            heatmapLoad:false,
            burstLoad:false,
            curveLoad:false,
            curveMetrics:{},

            tooltip: {
                trigger: "item",
                backgroundColor: "rgba(0,0,0,0.8)",
                borderColor: '#333',
                textStyle: {
                    color:'#fff'
                }
            },
            toolbox: {
                show: true,
                
                feature: { 
                    saveAsImage: {
                        title: '保存为图片',
                        show: true
                    }
                },
            }, 
            //生成报告
            isReport:false,  
            opts :{
                type: 'png', // 导出的格式，可选 png, jpeg
                pixelRatio: 1,// 导出的图片分辨率比例，默认为 1。
                backgroundColor: "#fff",// 导出的图片背景色，默认使用 option 里的 backgroundColor
                // excludeComponents: Array.<string>  // 忽略组件的列表，例如要忽略 toolbox 就是 ['toolbox'],一般也忽略了'toolbox'这栏就够了
            },
            imgUrlObj:{
                image1:'',//发文趋势
                image2:'',//作者分析
                image3:"",//作者网络
                image4:'',//省市地区
                image5:'',//机构分析 
                image6:"",//机构网络
                image7:"",//词云图
                image8:"",//关键词共现
                image9:"",//关键聚类
                image10:"",//关键词突变
                image11:'', //关键词未来5年频次预测
                image12:'', //关键词聚类折线图
            }, 
            graphList:[], 
            authorTable:[],//机构数据
            institutionGraph:[], 
            institutionTable:[],
            wordTable:[],
            keywordGraph:[],
            curveGraph:[],//关键词聚类图谱 
            keywordPairTable:[],
            keywordsBurst:'',
            keywordsMutation:[],
            keyworCurve:'',
            analysLoad:false,
            clusterScatterUrl:'',
            clusterScatterTable:[], //关键词聚类列表
            keyWordHeatmapUrl:'',
            keyword_centrality:[],//生成报告用 
        }
    },
    computed: {
        ...mapState({ 
            batchIdsArr:state=>state.bibliometric.batchIdsArr,
            batchIdsAnalysis:state=>state.bibliometric.batchIdsAnalysis
        }), 
    },
    watch: { 
    },
    mounted() {
        this.echartLine = this.$echarts.init(this.$refs.echarts_line,); 
        this.authorBar = this.$echarts.init(this.$refs.author_bar); 
        this.groupBar = this.$echarts.init(this.$refs.group_bar); 
        this.echartWord = this.$echarts.init(this.$refs.echarts_word);  
        this.myChartMap= this.$echarts.init(this.$refs.echart_map);
        this.echartsCurve=this.$echarts.init(this.$refs.echarts_curve);
        // this.keyWordHeatmap=this.$echarts.init(this.$refs.keyWord_heatmap);  
    },
    methods: {
        handleClick(tab, event) { 
              
        },
        getData(){ 
            this.init(); 
            for (let i = 1; i < 8; i++) {  
                this.get_analysisVisualization(i)
            }
            //关键词聚类单独请求
            this.analys_k();
        },
        init(){
            this.activeName='first'; 
            this.activeTabIndex=1;
            // this.analysisAll={};//全部数据
            this.graphList=[]; 
            this.authorTable=[];
            this.institutionGraph=[]; 
            this.institutionTable=[];
            this.wordTable=[];
            this.keywordGraph=[];
            this.curveGraph=[]; 
            this.curveMetrics={};
            this.keywordPairTable=[];
            this.keywordsBurst='';
            this.keywordsMutation=[];
            this.keyworCurve='';
            this.clusterScatterUrl='';
            this.clusterScatterTable=[];
            this.keyword_centrality=[];//生成报告用 
            this.keyWordHeatmapUrl='';
            // this.kValue='';
            this.loadingNum=0;
            for(let key in this.imgUrlObj){
                this.imgUrlObj[key]='';
                // console.log(this.imgUrlObj,'====')
            }
            this.lineLoad=false;
            this.authorLoad=false;
            this.groupLoad=false;
            this.wordLoad=false;
            this.keywordPairLoad=false;
            this.heatmapLoad=false;
            this.burstLoad=false;
            this.curveLoad=false;
        }, 
        get_analysisVisualization(type){
            this.lineLoad=true;
            this.authorLoad=true;
            this.groupLoad=true;
            this.wordLoad=true;
            this.keywordPairLoad=true;
            this.heatmapLoad=true;
            this.burstLoad=true;
            // this.curveLoad=true;
            analysisVisualization(type).then(res=>{
                let {code,data,msg} =res.data; 
                if(code==200){ 
                    if(type==1){ 
                        let dataList={
                            Xdata:data.trendData.xAxis.data||[],
                            Ydata:data.trendData.series[0].data||[]
                        }  
                        this.setLine(dataList);
                    }else if(type==2){  
                        this.authorTable=data.author_data; 
                        this.setAuthorBar(this.authorTable,data.Author_occur_data);
                        provinceCityStatistics().then(res=>{
                            let {code,data,msg} =res.data;
                            if(code==0){
                                this.setEcharts_map(data)
                            }else{
                                this.$message.error(msg||'请求失败～')
                            }
                        })
                    }else if(type==3){ 
                        this.institutionTable=data.institution_data 
                        this.setGroupBar(this.institutionTable,data.Institution_occur_data);
                    }else if(type==4){ 
                        this.wordTable=[];
                        this.keyword_centrality=data.keyword_centrality
                        data.keyword_centrality&&data.keyword_centrality.forEach(item => {
                            let obj={
                                center:item.center,
                                name:item.name,
                                value:item.count,
                            }
                            this.wordTable.push(obj)
                        });   
                        this.setWord(this.wordTable); 
                    }else if(type==5){  
                        this.keywordPairTable=data.keyword_pair_data;
                        this.keywordGraph=data.Keyword_occur_data;
                        this.keywordPairLoad=false;
                    }else if(type==6){  
                        this.keyWordHeatmapUrl=data.keyword_forecast_heatmap;
                        this.imgUrlObj.image11=this.keyWordHeatmapUrl ;
                        this.heatmapLoad=false;
                        // this.set_keyWordHeatmap(data.keyword_echarts.hours,data.keyword_echarts.days,data.keyword_echarts.data,)
                    }else if(type==7){ 
                        this.keywordsMutation=data.mutation_data; 
                        this.keywordsBurst=data.keywords_burst;
                        this.imgUrlObj.image10=this.keywordsBurst;
                        this.burstLoad=false;
                    }else if(type==8){ 
                        //this.keyworCurve = data.k_value_curve;
                        //this.curveLoad=false;
                        //this.imgUrlObj.image9=this.keyworCurve 
                    }
                }else{
                     this.$message.error(msg||'请求失败～');
                }
                // this.atlasLoad=false;
            })
        },
        //生成报告
        report(){
            this.isReport=true;
            let params={
                //keyWord:this.keyWord||'',
                //ids:this.batchIdsArr,
                //total:this.batchIdsArr.length,
                authorList:this.authorTable,
                institutionList:this.institutionTable,
                wordcloudList:this.keyword_centrality,
                keywordList:this.keywordPairTable,
                clusterList:this.clusterScatterTable,
                mutationList:this.keywordsMutation, 
                ...this.imgUrlObj,
            } 
            bibliometricsGenerateReport(params).then(res=>{ 
                this.isReport=false;
                this.down_blob(`计量可视化分析结果报告${new Date().getTime()}.doc`,res) 
            })
        },
        //网络图地址
        comples_img(type,val){ 
            if(type=='author'){
                this.imgUrlObj.image3=val;
            }else if(type=='group'){
                this.imgUrlObj.image6=val;
            }else if(type=='keywordPair'){
                this.imgUrlObj.image8=val;
            }else if(type=='curveLPair'){
                this.imgUrlObj.image9=val;
            }
        },
        down_blob(name,res,){ 
            let typeCount = {
                type: "application/octet-stream",
            };
            let _this=this;
            let blob = new Blob([res.data],typeCount); 
                let url = window.URL.createObjectURL(blob);
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link); 
            // }
        },
 
        setLine(data){
            let dataX=data.Xdata;
            let grid={
                left:'4%',
                right:'4%',
            }
            let chartOption = {  
                title: [
                    {
                        left: 'center',
                        text: '年份与文献数量统计'
                    }, 
                ],
                grid:dataX.length>15?grid:{} ,
                backgroundColor: "#fff", //背景色
				tooltip:this.tooltip,  
                toolbox:this.toolbox,
                grid:dataX.length>15?grid:{} , 
                xAxis: {
                    type: 'category',
                    data: dataX,
                    axisLabel: {
                        interval: 0, // 显示所有标签
                        rotate: dataX.length>15?45:0 // 旋转标签，以便更好地对齐
                    },
                    axisTick: {
                        alignWithLabel: true // 使刻度线与标签对齐
                    }
                     
                },
                yAxis: {
                    type: 'value',  
                    splitArea:{
                        show:true,
                        areaStyle:{
                            color:'#F1F5FE',
                        }
                    }
                },
                series: [
                    {
                        data: data.Ydata,
                        type: 'line',
                        label:{
                            show:true,
                            color:'red', 
                            fontSize:16
                        },  
                    }
                ]
            }
            this.echartLine.setOption(chartOption);
            setTimeout(() => {
                this.lineLoad=false;
                this.imgUrlObj.image1=this.echartLine.getDataURL(this.opts) ;
            }, 1000);
        },
        barOption(data,text,name){   
            let source=[['score', 'amount', 'product'],] 
            let numberArr=[];
            data.forEach(item=>{
                let arr=[
                    Number(item.count),
                    Number(item.count),
                    item.name
                ]
                numberArr.push(Number(item.count))
                source.push(arr)
            }) 
            let chartOption = { 
                tooltip: this.tooltip,   
                toolbox:this.toolbox,
                title:[
                    {
                        left: 'center',
                        text:text
                    }
                ],
                dataset: {
                    source:source,// data
                },
                grid: { containLabel: true },
                xAxis: { name: name},
                yAxis: { type: 'category' },
                visualMap: {
                    type:'continuous',
                    orient: 'horizontal',
                    left: 'center',
                    inverse:true,
                    min: 1,
                    max: Math.max(...numberArr)<10?10:Math.max(...numberArr),
                    text: ['高频次','低频次',], 
                    dimension: 0,
                    inRange: { 
                        color: [ '#65B581', '#FFCE34','#FD665F',]
                    }
                },
                series: [
                    {
                    type: 'bar',
                    encode: {
                        // Map the "amount" column to X axis.
                        x: 'amount',
                        // Map the "product" column to Y axis
                        y: 'product'
                    }
                    }
                ],
            }; 
            return  chartOption
        },
        setAuthorBar(data,Author_occur_data){    
            let chartOption =this.barOption(data,'TOP20 作者发文频次 ','发文频次') 
            this.authorBar.setOption(chartOption);
            this.graphList=[];
            this.graphList=Author_occur_data;
            
            setTimeout(() => {
                this.authorLoad=false;
                this.imgUrlObj.image2=this.authorBar.getDataURL(this.opts) ; 
            }, 1000);
        },
        setGroupBar(data,Institution_occur_data){    
            let chartOption =this.barOption(data,'TOP20 机构发文频次 ','发文频次') 
            this.groupBar.setOption(chartOption); 
            this.institutionGraph=[];
            this.institutionGraph=Institution_occur_data;
            setTimeout(() => { 
                this.groupLoad=false; 
                this.imgUrlObj.image5=this.groupBar.getDataURL(this.opts) ;
            }, 1000);
        },
        //地图
        setEcharts_map(mapTipData){   
            // console.log(mapTipData)
            this.$echarts.registerMap('CH', chinaJaon);
            this.$echarts.registerMap('chain_nh', chain_nh );
            let chartOption ={  
                visualMap: {
                    left: 'left',
                    min: 0,
                    max: 10,
                    inRange: {
                        color: [
                        '#b4ecf8',  
                        '#2baaeb',
                        '#0d8dce', 
                        '#02619e',
                        ]
                    },
                    text: ['高', '低'],
                    // calculable: true
                },
                tooltip: {
                    formatter:function(params){
                        if(params.data){

						   let list = params.data.list.toString();
                           let a =list.replace(/,/g, "<br>")
                            return params.name+':'  +params.value;
                        }
					}, 
                    ...this.tooltip,
                },  
                toolbox:this.toolbox, 
                itemStyle:{
                    areaColor :'#2eff2e',
                    borderColor:'#9c9c9c'
                },
                geo:[{
                        map: 'chain_nh',
                        zoom:.1, 
                        layoutCenter: ['85%', '80%'],//位置
	                    layoutSize:200,//大小
                        z:1,
                        default:false,
                        regions: [ {
                            name: "南海诸岛",
                               emphasis: { 
                                    itemStyle:{
                                        areaColor :'#2eff2e',
                                        borderColor:'#9c9c9c'
                                    }
                                },
                                itemStyle: {
                                    normal: {
                                        borderWidth: .5, //区域边框宽度
                                        borderColor: '#9c9c9c', //区域边框颜色
                                        areaColor: "#b4ecf8", //区域颜色
                                    },
                                },
                            }],
                        }
                ],
                series: [
                    {
                        z:1,
                        type: 'map',
                        roam: true,
                        name:'',
                        map: 'CH',
                        emphasis: { 
                            itemStyle:{
                                areaColor :'#2eff2e',
                                borderColor:'#9c9c9c'
                            }
                        },
                        itemStyle: {
                            normal: {
                                borderWidth: .5, //区域边框宽度
                                borderColor: '#9c9c9c', //区域边框颜色
                                areaColor: "#b4ecf8", //区域颜色
                            },
                        },
                        data:mapTipData
                    } 
                ]
            };
            this.myChartMap.setOption(chartOption)
            setTimeout(() => {  
                this.imgUrlObj.image4=this.myChartMap.getDataURL(this.opts) ; 
            }, 1000);
        },
        // 词云
        setWord(data){
            this.wordLoad=true;
            let chartOption ={  
                tooltip: this.tooltip, 
                toolbox:this.toolbox, 
                series: [{
                    type: "wordCloud", 
                    //用来调整词之间的距离
                    gridSize: 8,
                    //用来调整字的大小范围
                    sizeRange: [12, 36],
                    // //用来调整词的旋转方向，，[0,0]--代表着没有角度，也就是词为水平方向，需要设置角度参考注释内容
                    rotationRange: [-45, 45],
                    rotationStep: 45,//词云中文字的角度，
                    // 自动调整大小以适应容器
                    width: '100%',
                    height: '100%', 
                    //随机生成字体颜色
                    textStyle: {
                        fontFamily: "sans-serif",
                        // fontWeight: "bold",
                        // Color can be a callback function or a color string
                        color: function () {
                        // Random color
                            return ( "rgb(" +[
                                    Math.round(Math.random() * 225),
                                    Math.round(Math.random() * 225),
                                    Math.round(Math.random() * 225),
                                ].join(",") + ")");
                        },
                    },
                    emphasis: {
                        // focus: "self", 
                        textStyle: {
                            textShadowBlur: 14,
                            textShadowColor: '#a7a7a7'
                        }
                    },
                    //位置相关设置
                    left: "center",
                    top: "center",
                    right: null,
                    bottom: null, 
                    data,
                }],
            }; 
            this.echartWord.setOption(chartOption);  
            setTimeout(() => { 
                this.wordLoad=false;
                this.imgUrlObj.image7=this.echartWord.getDataURL(this.opts) ; 
            })
        },
        analys_k(){  
            this.curveLoad=true;
            analysisClusterKeywords().then(res=>{
                let {code,data,msg}=res.data;
                if(code==200){
                    this.curveGraph=data.cluster_info||[]; 
                    this.curveMetrics=data.metrics||{};
                    this.clusterScatterTable=data.core_cluster_table||[];
                    this.setCurveLine(data.yearly_trend)
                }else{
                    this.$message.error(msg||'请求失败～')
                }
                this.curveLoad=false;
            })
            // let path='bibliometric'
            // if(this.$route.path === '/bibliometricAtlasOut'){ 
            //     path='bibliometricOut'
            // }
            // this.$router.push({
            //     path,
            //     query:{ 
            //         changeflag:2
            //     }
            // }) 
        },
        setCurveLine(data){ 
            let dataX=data.xAxis.data;
            let grid={
                left:'4%',
                right:'4%',
            }
            let series=[];
            let legendData=[]
            data.series&&data.series.forEach(item=>{
                let obj={
                    //stack: 'Total',
                    ...item,
                }
                series.push(obj);
                legendData.push(item.name)
            }) 
            // console.log(legendData)
            let chartOption = {  
                title: [
                    {
                        left: 'center',
                        text: '关键词聚类信息分析'
                    }, 
                ],
                legend: {
                    data:legendData,
                    bottom:'0',
                    type:'scroll'
                },
                grid:dataX.length>15?grid:{} ,
                backgroundColor: "#fff", //背景色
				tooltip:{
                    trigger: 'axis'
                },//this.tooltip,  
                toolbox:this.toolbox,
                grid:dataX.length>15?grid:{} , 
                xAxis: {
                    type: 'category',
                    data: dataX,
                    axisLabel: {
                        interval: 0, // 显示所有标签
                        rotate: dataX.length>15?45:0 // 旋转标签，以便更好地对齐
                    },
                    axisTick: {
                        alignWithLabel: true // 使刻度线与标签对齐
                    }
                     
                },
                yAxis: {
                    type: 'value',  
                    splitArea:{
                        show:true,
                        areaStyle:{
                            color:'#F1F5FE',
                        }
                    }
                },
                series: series
            }
            this.echartsCurve.setOption(chartOption);
            setTimeout(() => {
                // this.lineLoad=false;
                this.imgUrlObj.image12=this.echartsCurve.getDataURL(this.opts) ;
            }, 1000);
        },
        save_pic(img,tit){ 
            try { 
                saveImge(img, tit+'.png');
            } catch (error) {
                console.error('图片保存失败:', error);
                // fallback到原始方法
                const fileName = tit+'.png';
                const link = document.createElement('a');
                link.href = img;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
}
</script>
<style lang='less' scoped>
.bibliometric-atlas{
    padding-bottom: 40px; 
    h2{
        padding-top: 40px;
        border-top:2px dashed #396de7;
        margin-bottom: 20px;
    }
    .atlas-top-btn{
        text-align: right;
    }
    .echarts-box{
        width: 1200px;
        height: 500px;
        margin-bottom: 40px;
        &.box-h{
            height: 700px;
        }
        &.word-box{
            height: 350px;
        }
    }
    .pane-img{
        width: 1000px;
        margin: 0 auto;
    }
    .demo-ruleForm{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 400px;
        .label{
            width: 80px;
            font-size: 16px;
            font-weight: bold;
        }
        .k-input{
            width: 240px;
        }
    }
    .down-img{
        display: flex;
        justify-content: flex-end;
        margin-bottom: 10px;
        .down{
            width: 16px;
            height: 16px;
            background: url('../../assets/images/bibliometric/down-img.png') no-repeat;
            background-size: cover;
            cursor: pointer;
        }
        
    }
    .curve-tit{
        display: flex;
        justify-content: center;
        font-size: 14px;
        font-weight: bold;
        p{
            margin: 10px;
        }
    }
}
</style>
